import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import {
    PANEL_CATEGORIES,
    PANEL_PRIORITIES,
    STATUS_LIST_PANEL_PREVIEW_IMAGE,
} from '../../page-framework/panel/PanelRegistry';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { useQueryLoader } from '../../data-table/Loaders';
import { filterId as radioFilterId } from '../../filters/radio-filter/RadioFilter';
import ReportingDataTable from '../../data-table/ReportingDataTable';
import { listTooltip } from '../ipm-list-panels/funcs/IpmList';
import { DEFAULT_INVALID_VALUE } from '../../../utilities/FormattingUtilities';
import { accessPointFilterId, timeRangeFilterId } from '../../filters';

const title = t`Access Point Radios`;

const dataSource = {
    url: '/query/table',
    params: {
        type: 'radio',
        renderAsEntity: true,
        entityFields: ['name', 'bssidList', 'band'],
        metrics: ['status', 'retryStatus', 'errorFrameStatus', 'channels', 'channelUtilizationStatus'],
        trends: ['status'],
    },
};

const columns = [
    {
        type: COLUMN_TYPES.LINK,
        title: t`Name`,
        sortable: true,
        mapping: 'radio.name',
        getTooltip: listTooltip('radio.name'),
        width: 175,
        link: {
            target: '../radio-detail',
            mappedFilterParams: {
                [radioFilterId]: 'radio',
            },
        },
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Channels`,
        sortable: true,
        sortProperty: 'channels',
        mapper: (row) => {
            const channels = row.channels || [];
            if (channels.length === 0) return DEFAULT_INVALID_VALUE;
            return channels.map((channel) => channel.channelNumber).join(', ');
        },
        width: 110,
    },
    {
        type: COLUMN_TYPES.STATUS,
        title: t`Channel Util.`,
        sortable: true,
        mapping: 'channelUtilizationStatus',
        width: 130,
    },
    {
        type: COLUMN_TYPES.STATUS,
        title: t`Retry Rate`,
        sortable: true,
        mapping: 'retryStatus',
        width: 120,
    },
    {
        type: COLUMN_TYPES.STATUS,
        title: t`Error Frame`,
        sortable: true,
        mapping: 'errorFrameStatus',
        width: 120,
    },
    {
        type: COLUMN_TYPES.STATUSTREND,
        title: t`Status Trend`,
        sortable: true,
        sortProperty: 'status',
        mapping: 'trends.status.data',
    },
];

const sorters = [{ property: 'status', direction: 'desc' }];

function AccessPointRadioListPanel(props) {
    const loader = useQueryLoader(dataSource);
    return (
        <ReportingDataTable
            panelProps={props}
            loader={loader}
            columns={columns}
            sorters={sorters}
            deletedMapping="radio.deleted"
        />
    );
}

AccessPointRadioListPanel.propTypes = panelPropTypes;

AccessPointRadioListPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    autoHeight: true,
    minContentHeight: 130,
};

export default Panel({
    typeAlias: 'AccessPointRadioList',
    catalogEntry: {
        category: PANEL_CATEGORIES.ACCESS_POINT,
        priority: PANEL_PRIORITIES.SUBLIST,
        title,
        description: t`List of radios on a selected wireless access point (AP), showing status trends`,
        previewImage: STATUS_LIST_PANEL_PREVIEW_IMAGE,
        ipm: true,
    },
    filters: {
        required: [timeRangeFilterId, accessPointFilterId],
        optional: [],
    },
})(AccessPointRadioListPanel);
